import type { DialogueTree } from './types';

/**
 * Best friend. Tone: bro voice, lowercase, types like he's still at brunch.
 * Genuinely supportive. Will absolutely yolo into your bad take. Believes
 * in you. Sometimes too much. Calls you "bro" no matter what.
 */
export const BEST_FRIEND_TREE: DialogueTree = {
  contactId: 'best_friend',
  rootChoices: [
    {
      id: 'sushi',
      label: 'sushi friday?',
      playerSays: "sushi friday?",
      responses: [
        { text: "bro yes. you owe me from october. and july. and the october before that. but yes." },
        { text: "i was gonna text you the same thing. spooky. in.\n\nyou\'re paying though. you\'re always paying. that\'s the dynamic." },
      ],
    },

    {
      id: 'tell-trade',
      label: 'tell him about the trade',
      playerSays: "i\'m up big on $TARI today",
      responses: [
        {
          text: "BRO. SCREENSHOT. NOW. I NEED TO SEE THE NUMBER.\n\ni\'m already in the discord telling everyone you\'re a genius. don\'t make me wrong.",
          followUps: [
            { id: 'trade-real', label: "yeah it\'s real. \$8K up.",
              playerSays: "real. up \$8K.",
              responses: [
                { text: "BRO.\n\nthis is your moment. the moment. i\'m unironically proud of you. don\'t lose this back. that\'s the only ask. don\'t lose this back." },
              ],
            },
            { id: 'trade-fake', label: "kinda paper but it counts",
              playerSays: "well. it\'s paper. but it counts.",
              responses: [
                { text: "bro it does NOT count until it\'s realized.\n\nbut respect for the energy." },
              ],
            },
          ],
        },
        {
          text: "first of all. respect.\n\nsecond of all. did you size up. i need to know if you sized up.",
          followUps: [
            { id: 'trade-sized-up', label: "i sized up bro",
              playerSays: "yeah bro. i sized up.",
              responses: [
                { text: "KING.\n\nokay if it goes the other way we\'re drinking on a wednesday. just so we\'re both prepared for the worst case." },
              ],
            },
          ],
        },
      ],
    },

    {
      id: 'borrow',
      label: 'ask to borrow money',
      playerSays: "bro i need to borrow something",
      responses: [
        {
          text: "how much we talking. and don\'t lie. i\'ll know.\n\ni\'m kinda broke too but i can probably do something.",
          followUps: [
            { id: 'borrow-small', label: "\$500. just till tuesday.",
              playerSays: "\$500. till tuesday. swear.",
              effects: [{ type: 'cash', value: 500 }, { type: 'rep', target: 'best_friend', value: -3 }, { type: 'note', value: 'best friend wired $500 — pay it back' }],
              responses: [
                { text: "ok bro. on its way. tuesday is, like, very specific. don\'t tuesday-the-tuesday.\n\nyou know what i mean." },
              ],
            },
            { id: 'borrow-big', label: "\$5K. it\'s urgent.",
              playerSays: "\$5K bro. urgent.",
              effects: [{ type: 'rep', target: 'best_friend', value: -8 }, { type: 'note', value: 'asked best friend for $5K — that\'s a lot to ask' }],
              responses: [
                { text: "bro i love you but i don\'t have \$5K to lend. i\'d have to ask my parents.\n\nare we at \"ask my parents\" energy.\n\nare you ok." },
              ],
            },
          ],
        },
      ],
    },

    {
      id: 'venting',
      label: 'vent about life',
      playerSays: "bro i\'m losing it",
      effects: [{ type: 'rep', target: 'best_friend', value: 3 }],
      responses: [
        {
          text: "bro i\'m here.\n\nwhat\'s going on. and don\'t do the thing where you say \"nothing\" and then we don\'t talk for 3 weeks. talk to me.",
          followUps: [
            { id: 'venting-deep', label: "everything. all of it.",
              playerSays: "everything bro. all of it.",
              effects: [{ type: 'rep', target: 'best_friend', value: 6 }, { type: 'sanity', value: 6 }],
              responses: [
                { text: "ok. i\'m driving over. don\'t argue. don\'t tweet through it. i\'ll be there in 40.\n\nbeer or whiskey. tell me on the way." },
              ],
            },
            { id: 'venting-deflect', label: "actually nvm. i\'m good.",
              playerSays: "actually nvm. i\'m good. forget i said anything.",
              effects: [{ type: 'rep', target: 'best_friend', value: -2 }, { type: 'sanity', value: -3 }],
              responses: [
                { text: "bro.\n\nthat\'s the thing i was talking about.\n\nok. i\'m here when you\'re ready. for real." },
              ],
            },
          ],
        },
      ],
    },

    {
      id: 'tell-him-jet',
      label: 'tell him you bought a jet',
      playerSays: "bro. i bought a jet.",
      requires: (ctx) => ctx.hasOwnedJet,
      responses: [
        {
          text: "BRO.\n\nBROOOO.\n\nWHEN ARE WE GOING SOMEWHERE.\n\nlike fr. when. i\'m flexible. i\'ll quit my job. don\'t test me.",
          followUps: [
            { id: 'jet-vegas', label: "vegas this weekend",
              playerSays: "vegas this weekend",
              effects: [{ type: 'cash', value: -8000 }, { type: 'rep', target: 'best_friend', value: 10 }, { type: 'note', value: '-$8K vegas weekend on the jet — best friend rep +10' }],
              responses: [
                { text: "I AM PACKING.\n\nthis is the highest moment of my life and yours has been higher this week. somehow. respect." },
              ],
            },
          ],
        },
      ],
    },

    {
      id: 'crypto-tip',
      label: 'pass him a crypto tip',
      playerSays: "bro. $JEET. trust me.",
      responses: [
        {
          text: "bro.\n\ni love you. i\'ll yolo. but if this rugs we are texting MUCH less for a while.\n\nlike. months less.",
          effects: [{ type: 'rep', target: 'best_friend', value: -2 }, { type: 'note', value: 'told best friend to yolo $JEET. this will be either a story or a fight.' }],
        },
      ],
    },

    {
      id: 'big-l',
      label: 'admit a big L',
      playerSays: "bro i blew up",
      effects: [{ type: 'rep', target: 'best_friend', value: 3 }, { type: 'sanity', value: 3 }],
      responses: [
        {
          text: "bro. F.\n\nF in the chat. respectfully.\n\nyou good though? like. actually?",
          followUps: [
            { id: 'l-yeah', label: "yeah. i\'ll be ok.",
              playerSays: "yeah. i\'ll be ok.",
              effects: [{ type: 'rep', target: 'best_friend', value: 5 }, { type: 'sanity', value: 4 }],
              responses: [
                { text: "ok. drinks tonight. on me actually for once. you can pay me back when you make it back. and you will. probably. eventually." },
              ],
            },
          ],
        },
      ],
    },

    {
      id: 'rage',
      label: 'snap at him',
      destructive: true,
      playerSays: "bro stop. just stop. i can\'t do bro voice right now.",
      effects: [{ type: 'rep', target: 'best_friend', value: -5 }],
      responses: [
        {
          text: "ok.\n\ni\'m here when you\'re ready.\n\nstill bro voice though. that\'s just how i talk now. it\'s structural.",
          followUps: [
            { id: 'rage-sorry', label: "sorry. i didn\'t mean it.",
              playerSays: "sorry. i didn\'t mean it bro.",
              effects: [{ type: 'rep', target: 'best_friend', value: 4 }],
              responses: [
                { text: "we good. we\'re always good.\n\ngo eat something. drink water. log off." },
              ],
            },
          ],
        },
      ],
    },

    {
      id: 'send-meme',
      label: 'send him a meme',
      playerSays: "[sent: a 4-panel screenshot of your account]",
      effects: [{ type: 'rep', target: 'best_friend', value: 2 }],
      responses: [
        { text: "BROOOO LMAOOOO\n\nthe panel where your account hits all-time low and the caption is just \"vibes\" — i\'m crying" },
        { text: "this is the kind of meme that should be in a museum.\n\nspecifically: a museum about how i lost my friend to gambling." },
        { text: "you ARE the meme bro. i\'ve always said this." },
      ],
    },

    {
      id: 'plan-trip',
      label: 'plan a vegas trip together',
      playerSays: "vegas. me, you, this weekend. yes?",
      effects: [{ type: 'cash', value: -3_500 }, { type: 'rep', target: 'best_friend', value: 8 }, { type: 'sanity', value: -4 }, { type: 'note', value: '-$3.5K vegas weekend with best friend. friend rep +8. sanity -4. you will not sleep.' }],
      responses: [
        { text: "BROOOO YES.\n\nbooked it. the suite has, allegedly, a hot tub. the hot tub is, in fact, just a deeper bathtub. but. yes." },
      ],
    },

    {
      id: 'check-on-him',
      label: 'check on him for once',
      playerSays: "bro how are YOU actually doing",
      effects: [{ type: 'rep', target: 'best_friend', value: 6 }, { type: 'sanity', value: 3 }],
      responses: [
        { text: "bro.\n\nthat\'s the first time you\'ve asked me first in 14 weeks. literally. i counted.\n\nhonest answer: kind of bad. but i\'m, like, working on it. i love you bro." },
      ],
    },
  ],
};
